<h2 mat-dialog-title>Duplica fattura</h2>
    <mat-dialog-content>
      <p>Sicuro di voler duplicare la fattura nelle bozze?</p>
      <mat-checkbox [(ngModel)]="confirmed">Confermo di voler duplicare la fattura e accetto</mat-checkbox>
    </mat-dialog-content>
    <mat-dialog-actions align="end">
      <button mat-button mat-dialog-close>Indietro</button>
      <button mat-raised-button color="primary" [disabled]="!confirmed" (click)="confirm()">
        <mat-icon>check</mat-icon>
        Confermo
      </button>
    </mat-dialog-actions>